import { useMediaQuery, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';

/**
 * Collapse and colour state shared by the side nav shell and the content rendered in it.
 */
export const useSideNavStyle = () => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	const { isCollapsed } = useSelector((state) => state.sideNavSlice);
	const { themeMode, invertSideNavColors } = useSelector((state) => state.userPrefs);
	const isLightMode = themeMode !== 'dark';
	const inverted = isLightMode && invertSideNavColors;

	return {
		collapsed: isCollapsed && !isMobile,
		isLightMode,
		inverted,
		sideNavItemColor: inverted ? theme.palette.sideNav : 'whitesmoke',
	};
};
